import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import { InspectionFireTaps } from '@authority-labs/api-interfaces';

@Component({
  selector: 'authority-labs-fire-taps',
  templateUrl: './fire-taps.component.html',
  styleUrls: ['./fire-taps.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FireTapsComponent {
  @Input() data: InspectionFireTaps;
  @Input() readonly: boolean;
  @Input() printPreview: boolean;
  @Output() dataChange: EventEmitter<void> = new EventEmitter();

  onDataChange(): void {
    this.dataChange.emit();
  }
}
